import { render, staticRenderFns } from "./AwardForm.vue?vue&type=template&id=ec284ac0&scoped=true"
import script from "./AwardForm.vue?vue&type=script&lang=js"
export * from "./AwardForm.vue?vue&type=script&lang=js"
import style0 from "./AwardForm.vue?vue&type=style&index=0&id=ec284ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec284ac0",
  null
  
)

export default component.exports